import http from '@util/http';
import { incubator } from '@api/req';

export async function queryBackList(params) {
  return http.get(incubator.BACK_LIST, params);
}
export async function queryBackMy(params) {
  return http.get(incubator.BACK_MY, params);
}
export async function queryBackInfo(params) {
  return http.get(incubator.BACK_INFO, params);
}
export async function querySaveBack(params) {
  return http.post(incubator.BACK_SAVE, params);
}
export async function queryNextBack(params) {
  return http.get(incubator.BACK_NEXT, params);
}
export async function queryReturnBack(params) {
  return http.post(incubator.BACK_RETURN, params);
}
export async function queryCallbackBack(params) {
  return http.get(incubator.BACK_CALLBACK, params);
}
export async function queryDeleteBack(params) {
  return http.get(incubator.BACK_DELETE, params);
}
export async function queryBackWorkflow(params) {
  return http.get(incubator.BACK_WORKFLOW, params);
}



// WEBPACK FOOTER //
// ./src/api/incubator/back.js